import SerializingLink from 'apollo-link-serialize';

export const serializingLink = new SerializingLink();

/// <reference types="@apollo/client" />
declare module '@apollo/client' {
  interface DefaultContext {
    /**
     * If provided, all operations with the same key will be serialized. That is,
     * if any operations with the same key are in progress, the operation will
     * wait until those operations have completed before being sent to the
     * network. All serialized operations will be sent eventually, in the order in
     * which they were initiated.
     *
     * @see https://www.npmjs.com/package/apollo-link-serialize
     */
    serializationKey?: string;
  }
}
